export const COMPANY_STATE_CLEARED = 'company.STATE_CLEARED';
export const GET_COMPANY_LIST_REQUEST = 'company.GET_COMPANY_LIST_REQUEST';
export const GET_COMPANY_LIST_SUCCESS = 'company.GET_COMPANY_LIST_SUCCESS';
export const GET_COMPANY_LIST_FAIL = 'company.GET_COMPANY_LIST_FAIL';
export const UPLOAD_COMPANY_LOGO_REQUEST = 'company.UPLOAD_COMPANY_LOGO_REQUEST';
export const UPLOAD_COMPANY_LOGO_SUCCESS = 'company.UPLOAD_COMPANY_LOGO_SUCCESS';
export const UPLOAD_COMPANY_LOGO_FAIL = 'company.UPLOAD_COMPANY_LOGO_FAIL';
export const CURRENT_COMPANY_SELECTED = 'company.CURRENT_COMPANY_SELECTED';
export const CREATE_COMPANY_INFO_REQUEST = 'company.CREATE_COMPANY_INFO_REQUEST';
export const CREATE_COMPANY_INFO_SUCCESS = 'company.CREATE_COMPANY_INFO_SUCCESS';
export const CREATE_COMPANY_INFO_FAIL = 'company.CREATE_COMPANY_INFO_FAIL';
export const UPDATE_COMPANY_INFO_REQUEST = 'company.UPDATE_COMPANY_INFO_REQUEST';
export const UPDATE_COMPANY_INFO_SUCCESS = 'company.UPDATE_COMPANY_INFO_SUCCESS';
export const UPDATE_COMPANY_INFO_FAIL = 'company.UPDATE_COMPANY_INFO_FAIL';
export const DELETE_COMPANY_INFO_REQUEST = 'company.DELETE_COMPANY_INFO_REQUEST';
export const DELETE_COMPANY_INFO_SUCCESS = 'company.DELETE_COMPANY_INFO_SUCCESS';
export const DELETE_COMPANY_INFO_FAIL = 'company.DELETE_COMPANY_INFO_FAIL';
// PROFILES
export const GET_COMPANY_PROFILE_LIST_REQUEST = 'company.GET_COMPANY_PROFILE_LIST_REQUEST';
export const GET_COMPANY_PROFILE_LIST_SUCCESS = 'company.GET_COMPANY_PROFILE_LIST_SUCCESS';
export const GET_COMPANY_PROFILE_LIST_FAIL = 'company.GET_COMPANY_PROFILE_LIST_FAIL';
export const CURRENT_COMPANY_PROFILE_SELECTED = 'company.CURRENT_COMPANY_PROFILE_SELECTED';
export const UPLOAD_COMPANY_PROFILE_LOGO_REQUEST = 'company.UPLOAD_COMPANY_PROFILE_LOGO_REQUEST';
export const UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS = 'company.UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS';
export const UPLOAD_COMPANY_PROFILE_LOGO_FAIL = 'company.UPLOAD_COMPANY_PROFILE_LOGO_FAIL';
export const CREATE_COMPANY_PROFILE_INFO_REQUEST = 'company.CREATE_COMPANY_PROFILE_INFO_REQUEST';
export const CREATE_COMPANY_PROFILE_INFO_SUCCESS = 'company.CREATE_COMPANY_PROFILE_INFO_SUCCESS';
export const CREATE_COMPANY_PROFILE_INFO_FAIL = 'company.CREATE_COMPANY_PROFILE_INFO_FAIL';
export const UPDATE_COMPANY_PROFILE_INFO_REQUEST = 'company.UPDATE_COMPANY_PROFILE_INFO_REQUEST';
export const UPDATE_COMPANY_PROFILE_INFO_SUCCESS = 'company.UPDATE_COMPANY_PROFILE_INFO_SUCCESS';
export const UPDATE_COMPANY_PROFILE_INFO_FAIL = 'company.UPDATE_COMPANY_PROFILE_INFO_FAIL';
export const DELETE_COMPANY_PROFILE_INFO_REQUEST = 'company.DELETE_COMPANY_PROFILE_INFO_REQUEST';
export const DELETE_COMPANY_PROFILE_INFO_SUCCESS = 'company.DELETE_COMPANY_PROFILE_INFO_SUCCESS';
export const DELETE_COMPANY_PROFILE_INFO_FAIL = 'company.DELETE_COMPANY_PROFILE_INFO_FAIL';
// COMPANY ADMIN USERS
export const GET_COMPANY_ADMIN_LIST_REQUEST = 'company.GET_COMPANY_ADMIN_LIST_REQUEST';
export const GET_COMPANY_ADMIN_LIST_SUCCESS = 'company.GET_COMPANY_ADMIN_LIST_SUCCESS';
export const GET_COMPANY_ADMIN_LIST_FAIL = 'company.GET_COMPANY_ADMIN_LIST_FAIL';
export const CURRENT_COMPANY_ADMIN_SELECTED = 'company.CURRENT_COMPANY_ADMIN_SELECTED';
export const CREATE_COMPANY_ADMIN_INFO_REQUEST = 'company.CREATE_COMPANY_ADMIN_INFO_REQUEST';
export const CREATE_COMPANY_ADMIN_INFO_SUCCESS = 'company.CREATE_COMPANY_ADMIN_INFO_SUCCESS';
export const CREATE_COMPANY_ADMIN_INFO_FAIL = 'company.CREATE_COMPANY_ADMIN_INFO_FAIL';
export const UPDATE_COMPANY_ADMIN_INFO_REQUEST = 'company.UPDATE_COMPANY_ADMIN_INFO_REQUEST';
export const UPDATE_COMPANY_ADMIN_INFO_SUCCESS = 'company.UPDATE_COMPANY_ADMIN_INFO_SUCCESS';
export const UPDATE_COMPANY_ADMIN_INFO_FAIL = 'company.UPDATE_COMPANY_ADMIN_INFO_FAIL';
export const DELETE_COMPANY_ADMIN_INFO_REQUEST = 'company.DELETE_COMPANY_ADMIN_INFO_REQUEST';
export const DELETE_COMPANY_ADMIN_INFO_SUCCESS = 'company.DELETE_COMPANY_ADMIN_INFO_SUCCESS';
export const DELETE_COMPANY_ADMIN_INFO_FAIL = 'company.DELETE_COMPANY_ADMIN_INFO_FAIL';
// SCB ADMIN USERS
export const GET_ADMIN_USER_LIST_REQUEST = 'company.GET_ADMIN_USER_LIST_REQUEST';
export const GET_ADMIN_USER_LIST_SUCCESS = 'company.GET_ADMIN_USER_LIST_SUCCESS';
export const GET_ADMIN_USER_LIST_FAIL = 'company.GET_ADMIN_USER_LIST_FAIL';
export const CREATE_ADMIN_USER_REQUEST = 'company.CREATE_ADMIN_USER_REQUEST';
export const CREATE_ADMIN_USER_SUCCESS = 'company.CREATE_ADMIN_USER_SUCCESS';
export const CREATE_ADMIN_USER_FAIL = 'company.CREATE_ADMIN_USER_FAIL';
export const UPDATE_ADMIN_USER_REQUEST = 'company.UPDATE_ADMIN_USER_REQUEST';
export const UPDATE_ADMIN_USER_SUCCESS = 'company.UPDATE_ADMIN_USER_SUCCESS';
export const UPDATE_ADMIN_USER_FAIL = 'company.UPDATE_ADMIN_USER_FAIL';
export const DELETE_ADMIN_USER_REQUEST = 'company.DELETE_ADMIN_USER_REQUEST';
export const DELETE_ADMIN_USER_SUCCESS = 'company.DELETE_ADMIN_USER_SUCCESS';
export const DELETE_ADMIN_USER_FAIL = 'company.DELETE_ADMIN_USER_FAIL';
export const UNBLOCK_ADMIN_USER_REQUEST = 'company.UNBLOCK_ADMIN_USER_REQUEST';
export const UNBLOCK_ADMIN_USER_SUCCESS = 'company.UNBLOCK_ADMIN_USER_SUCCESS';
export const UNBLOCK_ADMIN_USER_FAIL = 'company.UNBLOCK_ADMIN_USER_FAIL';
export const GET_ADMIN_MY_ADMIN_INFO_REQUEST = 'company.GET_ADMIN_MY_ADMIN_INFO_REQUEST';
export const GET_ADMIN_MY_ADMIN_INFO_SUCCESS = 'company.GET_ADMIN_MY_ADMIN_INFO_SUCCESS';
export const GET_ADMIN_MY_ADMIN_INFO_FAIL = 'company.GET_ADMIN_MY_ADMIN_INFO_FAIL';



// WEBPACK FOOTER //
// ./src/store/mutations/company.js